// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__NJQP6"};